import React from 'react';

import { WEB_VISOR_DISABLE, WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { mask } from 'app/utils/StringUtils';
import { FieldSet } from 'app/component/fieldset/FieldSet';
import { FormatUtils } from 'app/utils/FormatUtils';
import { IdentityDocumentModal } from 'app/logic/pages/order/IdentityDocumentModal';
import { CardOrder } from 'app/model/CardOrder';
import { Reference } from 'app/model/Reference';
import { Section } from 'app/component/Section';

export interface PersonalDataFieldSetProps {
    /**
     * Заявка на карту
     */
    order: CardOrder;

    /**
     * Тип документа
     */
    documentType: Reference;

    /**
     * Значение справочника для поля "Резиденство"
     */
    residencyCountryReference: Reference;

    /**
     * Значение справочника для поля "Гражданство"
     */
    citizenshipCountryReference: Reference;
}

/**
 * Блок отображения личных данных пользователя
 * @constructor
 */
export const PersonalDataFieldSet = ({
    order,
    documentType,
    ...props
}: PersonalDataFieldSetProps) => {
    return (
        <Section
            className={'personalClientDataSection'}
            title={'Личные данные'}
            content={
                <FieldSet
                    className={'personalDataFieldSet'}
                    fieldsProps={[
                        {
                            className: 'fioRu',
                            title: 'ФИО',
                            value: (
                                <span className={WEB_VISOR_HIDE}>
                                    {order.client.surname} {order.client.name}{' '}
                                    {order.client.patronymic}
                                </span>
                            ),
                        },
                        {
                            className: 'fioEn',
                            title: 'Фамилия и имя латиницей',
                            value: (
                                <span className={WEB_VISOR_HIDE}>
                                    {order.client.surnameLatin}{' '}
                                    {order.client.nameLatin}
                                </span>
                            ),
                            isVisible:
                                !!order.client.surnameLatin &&
                                !!order.client.nameLatin,
                        },
                        {
                            className: 'birthdate',
                            title: 'Дата рождения',
                            value: (
                                <span className={WEB_VISOR_HIDE}>
                                    {order.client.birthDate.format(
                                        FormatUtils.DEFAULT_DATE_FORMAT,
                                    )}
                                </span>
                            ),
                        },
                        {
                            className: 'personalNumber',
                            title: 'Идентификационный номер',
                            value: (
                                <span className={WEB_VISOR_HIDE}>
                                    {order.client.identity.personalNumber}
                                </span>
                            ),
                        },
                        {
                            className: 'documentType',
                            title: 'Тип документа',
                            value: (
                                <IdentityDocumentModal
                                    documentType={documentType}
                                    order={order}
                                    residencyCountryReference={
                                        props.residencyCountryReference
                                    }
                                    citizenshipCountryReference={
                                        props.citizenshipCountryReference
                                    }
                                />
                            ),
                        },
                        {
                            className: 'phone',
                            title: 'Номер мобильного телефона',
                            value: (
                                <span className={WEB_VISOR_HIDE}>
                                    {mask(
                                        order.client.mobilePhone,
                                        FormatUtils.BELARUS_PHONE_MASK,
                                    )}
                                </span>
                            ),
                        },
                    ]}
                />
            }
        />
    );
};
